import { Outlet, createFileRoute } from "@tanstack/react-router"
import { changeProjectDetailQuery } from "@/features/change-projects/core/detailQuery"
import { changeProjectPreviewQueryKeys } from "@/features/change-projects/core/previewQueryKeys"
import { sourceChangesQueryKey } from "@/features/change-projects/hooks/useSourceChanges"
import { refreshChangeProjectSourcesFn } from "@/features/change-projects/server/changeProjects"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId")({
  loader: async ({ context, params }) => {
    const { queryClient } = context
    const changeProjectId = params.changeProjectId

    // Every target follows its store, so bring them onto the blueprint that store
    // counts as right now before anything is shown (BLU-677). A failure here must
    // never keep the planner out of their bulk update.
    let changed = false
    try {
      const changes = await refreshChangeProjectSourcesFn({ data: { changeProjectId } })
      queryClient.setQueryData(sourceChangesQueryKey(changeProjectId), changes)
      changed = changes.changed
    } catch (error) {
      console.error("[bulk-updates] could not refresh blueprint sources", error)
    }

    if (changed) {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["change-projects", "review-decisions", changeProjectId],
        }),
        queryClient.invalidateQueries({
          queryKey: changeProjectPreviewQueryKeys.all(changeProjectId),
        }),
      ])
    }

    // Fetched rather than ensured: a blueprint may have been swapped by someone
    // else, so a copy from minutes ago can still name targets that no longer
    // exist, and a decision taken on such a row would land on nothing.
    await queryClient.fetchQuery(changeProjectDetailQuery(changeProjectId))
  },
  component: () => <Outlet />,
})
